import { render, staticRenderFns } from "./ImageTab.vue?vue&type=template&id=d264782e&"
import script from "./ImageTab.vue?vue&type=script&lang=js&"
export * from "./ImageTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports